import { combineReducers } from "redux";

import token from "./token";
import fetching from "./fetching";

export default combineReducers({ token, fetching });
